const CATEGORY_PATH = /\/barber\/[^/]+\/group\/[^/]+\/[^/]+\/?$/;

/**
 * True when a web pathname is the schedule step or this flow's service list:
 * `/services` or the category route (`.../group/<L1 id>/<L2 id>`, not the L2
 * list `.../group/<L1 id>`).
 */
export function isServicesStepWebPath(pathname: string): boolean {
  return (
    pathname.endsWith('/schedule') ||
    pathname.endsWith('/services') ||
    CATEGORY_PATH.test(pathname)
  );
}
